var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnexionImageFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1641.791,
    height: 695.04,
    viewBox: "0 0 1641.791 695.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9349",
    "data-name": "Groupe 9349",
    transform: "translate(-1.662 -17.474)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9269",
    "data-name": "Groupe 9269",
    transform: "translate(19.604 18.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9266",
    "data-name": "Groupe 9266",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9250",
    "data-name": "Groupe 9250",
    transform: "translate(120.937 149.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16039",
    "data-name": "Trac\\xE9 16039",
    d: "M1444.345,458.851l-92.419-61.971L944.263,342.661l.68-1.7,127.51-318.138L863.961,194.078,595.155,65.27,336.419,427.716l-118.2-256.738L3.275,259.67,294.069,33.95l1.759,2.234L21.606,249.041l198-81.7,117.3,254.792L594.192,61.725,863.5,190.774,1079.206,13.6,948.237,340.365l404.655,53.819.28.188,92.7,62.159Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9251",
    "data-name": "Groupe 9251",
    transform: "translate(1060.346 13.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16040",
    "data-name": "Trac\\xE9 16040",
    d: "M259.171,661.206l-.892-.644L6.037,478.634l1.608-2.263L258.993,657.656l151.867-126.2L234.874,371.585,234.5,373.4l-1.669-3.672-1.261-1.146.6-.318-97.023-213.51,2.555-1.107L233.469,364.4,307.723,3.878,545.238,204.283,236.4,369.222l178.742,162.37ZM309.543,9.043,235.977,366.231,540.268,203.719Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9252",
    "data-name": "Groupe 9252",
    transform: "translate(969.409 230.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16041",
    "data-name": "Trac\\xE9 16041",
    d: "M0,0",
    fill: "none",
    stroke: "#f2f2f2",
    strokeWidth: 5.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9253",
    "data-name": "Groupe 9253",
    transform: "translate(1.41 111.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16042",
    "data-name": "Trac\\xE9 16042",
    d: "M192.787,564.785,131.1,294.409,46.447,361.622,0,.324,2.792.035l45.8,356.257,84.244-66.884L194.16,558.235l261.647-347.4,1.112.758L740.412,404.807,767.8,282.155l2.744.677-28.267,126.6-1.7-1.16L456.487,214.658Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9254",
    "data-name": "Groupe 9254",
    transform: "translate(44.419 203.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16043",
    "data-name": "Trac\\xE9 16043",
    d: "M150.823,472.182,3.375,267.559l2.267-1.6L150.106,466.439,295.34,110.986,413.8,368.285l310.7-178.672L669.847,9.226l2.689-.751,55.287,182.5L412.568,372.268l-.659-1.432-116.387-252.8Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9255",
    "data-name": "Groupe 9255",
    transform: "translate(1319.428 672.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16044",
    "data-name": "Trac\\xE9 16044",
    d: "M0,0",
    fill: "none",
    stroke: "#f2f2f2",
    strokeWidth: 5.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9256",
    "data-name": "Groupe 9256",
    transform: "translate(936.966 97.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16045",
    "data-name": "Trac\\xE9 16045",
    d: "M31.419,134.532.008.609,2.744.035,33.468,131.029,259.393,68.258l.816,2.707Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9257",
    "data-name": "Groupe 9257",
    transform: "translate(127.715 103.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16046",
    "data-name": "Trac\\xE9 16046",
    d: "M331.293,473.463l-2.036-1.071L3.8,301.174l.6-1.229L149.389,1.882l2.534,1.279L7.528,300,328.482,468.843l-.045-247.957.318-.381L404.2,130.483,283.6,80.922,558.608,16.166l-151.1,114.8-76.259,91ZM292.744,81.671l113.535,46.657L546.263,21.974Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9258",
    "data-name": "Groupe 9258",
    transform: "translate(2.77 85.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16047",
    "data-name": "Trac\\xE9 16047",
    d: "M768.538,310.1l-1-.224-312.9-69.72L336.68,234.108l-.313-.193L.346,27.441l1.428-2.382L337.481,231.341l117.462,6.023.117.026,312.019,69.524L934.345,11.774,936.8,13.2Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9259",
    "data-name": "Groupe 9259",
    transform: "translate(680.15 122.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16048",
    "data-name": "Trac\\xE9 16048",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeWidth: 5.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9260",
    "data-name": "Groupe 9260",
    transform: "translate(1292.927 382.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16187",
    "data-name": "Trac\\xE9 16187",
    d: "M0,0,2.805.035l3.65,291.587-2.805-.035Z",
    transform: "matrix(0.997, -0.074, 0.074, 0.997, 0.003, 0.207)",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9261",
    "data-name": "Groupe 9261",
    transform: "translate(1193.928 15.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16049",
    "data-name": "Trac\\xE9 16049",
    d: "M303.214,366.5,174.433,7.024,3.77,153.435l-1.861-2.15L175.671,2.214l.7,1.962L305.859,365.616Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9262",
    "data-name": "Groupe 9262",
    transform: "translate(713.459 93.946)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16050",
    "data-name": "Trac\\xE9 16050",
    d: "M2.82,120.154l-1.336-2.5L224.69,2.831l.525.141,258.425,69.29-.664,2.711L225.075,5.824Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9263",
    "data-name": "Groupe 9263",
    transform: "translate(2.44 100.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16051",
    "data-name": "Trac\\xE9 16051",
    d: "M1472.3,444.381l-2.778-.493,24.863-161.961-202.136.992L1065.154,391.493l-.251.021L735.4,420.008l245.327-179.64L965.737,131.3l-252.29-17.777-259.213,112.2L413.053,87.243,338.637,218.476l-2.454-1.431L411.229,84.7.159,12.611.3,9.824,276.258,3.481l.348.2L413.9,82.33l.634.111.09.3.737.422-.4.707,41.037,138L712.894,110.674l.34.024L968.2,128.664l15.531,113.024-.655.48L745.228,416.333l319.112-27.594,227.2-108.625.312,0,205.82-1.009-.255,1.659ZM14.61,12.306,405.847,80.917,275.6,6.308Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9264",
    "data-name": "Groupe 9264",
    transform: "translate(532.631 119.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16052",
    "data-name": "Trac\\xE9 16052",
    d: "M1.791,114.614l-.381-2.791,179.6-20.007L146.211,2.84l2.615-.965,36.118,92.337Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9265",
    "data-name": "Groupe 9265",
    transform: "translate(679.652 120.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16053",
    "data-name": "Trac\\xE9 16053",
    d: "M623.457,263.958,304.869,222.3l.3-2.785L605.9,258.839,289.241,111.159.033,2.638.963.012l289.311,108.56.051.024Z",
    transform: "translate(0 0)",
    fill: "#002b53",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9267",
    "data-name": "Groupe 9267",
    transform: "translate(769.511 337.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16054",
    "data-name": "Trac\\xE9 16054",
    d: "M296.45,154.086,214.468,5.967,1.434,58.222.7,55.494,215.848,2.72l.536.968L298.9,152.775Z",
    fill: "#002b53",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9268",
    "data-name": "Groupe 9268",
    transform: "translate(1191.455 165.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16055",
    "data-name": "Trac\\xE9 16055",
    d: "M307.422,217.754l-1.206-.855L0,0,414.043,50.744ZM10.623,4.123,306.6,213.768,409.245,52.977Z",
    fill: "#002b53",
    opacity: 0.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9348",
    "data-name": "Groupe 9348",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9272",
    "data-name": "Groupe 9272",
    transform: "translate(47.499 468.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9271",
    "data-name": "Groupe 9271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9270",
    "data-name": "Groupe 9270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16291",
    "data-name": "Trac\\xE9 16291",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9275",
    "data-name": "Groupe 9275",
    transform: "translate(414.438 181.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9274",
    "data-name": "Groupe 9274",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9273",
    "data-name": "Groupe 9273"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_637",
    "data-name": "Ellipse 637",
    cx: 14.516,
    cy: 14.886,
    rx: 14.516,
    ry: 14.886,
    transform: "translate(0.262 20.772) rotate(-45)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9278",
    "data-name": "Groupe 9278",
    transform: "translate(1.38 109.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9277",
    "data-name": "Groupe 9277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9276",
    "data-name": "Groupe 9276",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16292",
    "data-name": "Trac\\xE9 16292",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9281",
    "data-name": "Groupe 9281",
    transform: "translate(193.442 670.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9280",
    "data-name": "Groupe 9280",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9279",
    "data-name": "Groupe 9279",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16312",
    "data-name": "Trac\\xE9 16312",
    d: "M14.51.016A14.736,14.736,0,0,1,29.035,14.911,14.659,14.659,0,0,1,14.542,29.774,14.736,14.736,0,0,1,.016,14.879,14.659,14.659,0,0,1,14.51.016Z",
    transform: "translate(0.255 20.232) rotate(-43.53)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9284",
    "data-name": "Groupe 9284",
    transform: "translate(276.985 103.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9283",
    "data-name": "Groupe 9283",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9282",
    "data-name": "Groupe 9282",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16188",
    "data-name": "Trac\\xE9 16188",
    d: "M14.512.035A14.782,14.782,0,0,1,29.059,14.946,14.614,14.614,0,0,1,14.582,29.788,14.782,14.782,0,0,1,.035,14.876,14.614,14.614,0,0,1,14.512.035Z",
    transform: "translate(0.241 19.112) rotate(-40.586)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9287",
    "data-name": "Groupe 9287",
    transform: "translate(131.949 401.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9286",
    "data-name": "Groupe 9286",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9285",
    "data-name": "Groupe 9285",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16293",
    "data-name": "Trac\\xE9 16293",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9290",
    "data-name": "Groupe 9290",
    transform: "translate(456.139 321.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9289",
    "data-name": "Groupe 9289",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9288",
    "data-name": "Groupe 9288",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16189",
    "data-name": "Trac\\xE9 16189",
    d: "M14.511.026a14.761,14.761,0,0,1,14.537,14.9A14.635,14.635,0,0,1,14.563,29.782,14.761,14.761,0,0,1,.026,14.878,14.635,14.635,0,0,1,14.511.026Z",
    transform: "translate(0.248 19.63) rotate(-41.932)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9293",
    "data-name": "Groupe 9293",
    transform: "translate(338.432 315.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9292",
    "data-name": "Groupe 9292",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9291",
    "data-name": "Groupe 9291",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16190",
    "data-name": "Trac\\xE9 16190",
    d: "M14.511.026a14.761,14.761,0,0,1,14.537,14.9A14.635,14.635,0,0,1,14.563,29.782,14.761,14.761,0,0,1,.026,14.878,14.635,14.635,0,0,1,14.511.026Z",
    transform: "translate(0.248 19.63) rotate(-41.932)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9296",
    "data-name": "Groupe 9296",
    transform: "translate(984.08 339.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9295",
    "data-name": "Groupe 9295",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9294",
    "data-name": "Groupe 9294",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16294",
    "data-name": "Trac\\xE9 16294",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9299",
    "data-name": "Groupe 9299",
    transform: "translate(532.784 230.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9298",
    "data-name": "Groupe 9298",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9297",
    "data-name": "Groupe 9297"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_645",
    "data-name": "Ellipse 645",
    cx: 14.516,
    cy: 14.886,
    rx: 14.516,
    ry: 14.886,
    transform: "translate(0.262 20.772) rotate(-45)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9302",
    "data-name": "Groupe 9302",
    transform: "translate(741.324 516.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9301",
    "data-name": "Groupe 9301",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9300",
    "data-name": "Groupe 9300",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16295",
    "data-name": "Trac\\xE9 16295",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9305",
    "data-name": "Groupe 9305",
    transform: "translate(678.722 119.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9304",
    "data-name": "Groupe 9304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9303",
    "data-name": "Groupe 9303",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16296",
    "data-name": "Trac\\xE9 16296",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9308",
    "data-name": "Groupe 9308",
    transform: "translate(769.15 391.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9307",
    "data-name": "Groupe 9307",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9306",
    "data-name": "Groupe 9306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16297",
    "data-name": "Trac\\xE9 16297",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9311",
    "data-name": "Groupe 9311",
    transform: "translate(936.913 95.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9310",
    "data-name": "Groupe 9310",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9309",
    "data-name": "Groupe 9309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16298",
    "data-name": "Trac\\xE9 16298",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9314",
    "data-name": "Groupe 9314",
    transform: "translate(456.168 571.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9313",
    "data-name": "Groupe 9313",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9312",
    "data-name": "Groupe 9312",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16299",
    "data-name": "Trac\\xE9 16299",
    d: "M14.51.02a14.747,14.747,0,0,1,14.53,14.9,14.649,14.649,0,0,1-14.49,14.858A14.747,14.747,0,0,1,.02,14.879,14.649,14.649,0,0,1,14.51.02Z",
    transform: "matrix(0.733, -0.68, 0.68, 0.733, 0.252, 19.984)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9317",
    "data-name": "Groupe 9317",
    transform: "translate(967.981 228.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9316",
    "data-name": "Groupe 9316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9315",
    "data-name": "Groupe 9315",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16300",
    "data-name": "Trac\\xE9 16300",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9320",
    "data-name": "Groupe 9320",
    transform: "translate(714.182 210.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9319",
    "data-name": "Groupe 9319",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9318",
    "data-name": "Groupe 9318",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16301",
    "data-name": "Trac\\xE9 16301",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9323",
    "data-name": "Groupe 9323",
    transform: "translate(1601.67 214.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9322",
    "data-name": "Groupe 9322",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9321",
    "data-name": "Groupe 9321",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16302",
    "data-name": "Trac\\xE9 16302",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9326",
    "data-name": "Groupe 9326",
    transform: "translate(1367.551 17.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9325",
    "data-name": "Groupe 9325",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9324",
    "data-name": "Groupe 9324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16303",
    "data-name": "Trac\\xE9 16303",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9329",
    "data-name": "Groupe 9329",
    transform: "translate(1564.616 604.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9328",
    "data-name": "Groupe 9328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9327",
    "data-name": "Groupe 9327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16304",
    "data-name": "Trac\\xE9 16304",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9332",
    "data-name": "Groupe 9332",
    transform: "translate(1292.902 379.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9331",
    "data-name": "Groupe 9331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9330",
    "data-name": "Groupe 9330",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16305",
    "data-name": "Trac\\xE9 16305",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9335",
    "data-name": "Groupe 9335",
    transform: "translate(1317.999 670.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9334",
    "data-name": "Groupe 9334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9333",
    "data-name": "Groupe 9333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16306",
    "data-name": "Trac\\xE9 16306",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9338",
    "data-name": "Groupe 9338",
    transform: "translate(1497.035 378.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9337",
    "data-name": "Groupe 9337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9336",
    "data-name": "Groupe 9336",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16307",
    "data-name": "Trac\\xE9 16307",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9341",
    "data-name": "Groupe 9341",
    transform: "translate(1065.758 488.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9340",
    "data-name": "Groupe 9340",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9339",
    "data-name": "Groupe 9339",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16308",
    "data-name": "Trac\\xE9 16308",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9344",
    "data-name": "Groupe 9344",
    transform: "translate(1471.917 542.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9343",
    "data-name": "Groupe 9343",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9342",
    "data-name": "Groupe 9342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16309",
    "data-name": "Trac\\xE9 16309",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9347",
    "data-name": "Groupe 9347",
    transform: "translate(1195.338 164.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9346",
    "data-name": "Groupe 9346",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9345",
    "data-name": "Groupe 9345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16310",
    "data-name": "Trac\\xE9 16310",
    d: "M14.51.022a14.752,14.752,0,0,1,14.533,14.9A14.644,14.644,0,0,1,14.555,29.779,14.752,14.752,0,0,1,.022,14.878,14.644,14.644,0,0,1,14.51.022Z",
    transform: "translate(0.25 19.851) rotate(-42.514)",
    fill: "#002b53",
    opacity: 0.1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnexionImageFront);
export default __webpack_public_path__ + "static/media/connexion_image_front.db6fcf44eb9136339e793eb69ecb0281.svg";
export { ForwardRef as ReactComponent };